import React from 'react';

const ListWidget = ({ list, isResizable = false }) => {
  if (!list?.items || !Array.isArray(list.items)) {
    return <div className="text-gray-500 p-4">No list data available</div>;
  }
  return (
    <div className={`space-y-3 p-1 ${isResizable ? 'h-full overflow-y-auto' : ''}`}>
      {list.items.map((item, idx) => (
        <div key={idx} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
          <div className="flex-1 min-w-0">
            <div className="font-medium text-gray-900 truncate">{item.title}</div>
            {item.subtitle && <div className="text-xs text-gray-500 truncate">{item.subtitle}</div>}
          </div>
          <div className="flex items-center space-x-2 flex-shrink-0">
            <div className="text-lg font-bold">{item.value}</div>
            {item.trend && (
              <div className={`text-xs font-medium px-2 py-1 rounded ${
                item.trend.direction === 'up' ? 'bg-green-100 text-green-600' :
                item.trend.direction === 'down' ? 'bg-red-100 text-red-600' :
                'bg-gray-100 text-gray-600'
              }`}>
                <span>{item.trend.value}</span>
                <span className="ml-1">
                  {item.trend.direction === 'up' ? '↑' : item.trend.direction === 'down' ? '↓' : '→'}
                </span>
              </div>
            )}
            {item.badge && (
              <div className="text-xs font-medium px-2 py-1 rounded text-white" style={{ backgroundColor: item.badge.color }}>
                {item.badge.text}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListWidget;